<template>
  <div class="absolute w-screen h-screen overflow-hidden z-[10000] bg-red-600">
    <div class="w-full h-full overflow-y-auto">
      <div class="h-[44px] mx-4 my-10 px-2 py-1 flex flex-row justify-between items-center">
        <div>
          <LogoInverse class="h-5" />
        </div>
        <VaButton color="white" round class="w-[44px] h-[44px]" @click="hideSidebar">
          <VaIcon name="close" size="28px" color="red-600" @click="hideSidebar" />
        </VaButton>
      </div>

      <div class="p-4">
        <VaMenuList>
          <RouterLink
            v-for="item in menuItems" :key="item.textKey"
            :to="item.route" @click="hideSidebar"
          >
            <VaMenuItem class="text-2xl text-white">
              {{ t(item.textKey) }}
            </VaMenuItem>
          </RouterLink>
        </VaMenuList>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { VaButton, VaIcon, VaMenuItem, VaMenuList } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'
import { EventBus } from '@/services/event-bus/EventBus'
import LogoInverse from '@/assets/images/logo-inverse.svg'
import { useUserStore } from '@/stores/UserStore'
import { computed } from 'vue'

const userStore = useUserStore()
const { t } = useI18n()

const hideSidebar = () => {
  EventBus.dispatch('hideSidebar')
}

const menuItems = [
  {
    route: { name: 'products' },
    textKey: 'menu.products',
    children: [
      {
        route: { name: 'products', params: { product: 'starter' } },
        textKey: 'menu.productsStarter',
      },
      {
        route: { name: 'products', params: { product: 'pro' } },
        textKey: 'menu.productsPro',
      },
    ],
  },
  {
    route: { name: 'solutions' },
    textKey: 'menu.solutions',
    children: [
      {
        route: { name: 'solutions', params: { industry: 'retail' } },
        textKey: 'menu.solutionsRetail',
      },
      {
        route: { name: 'solutions', params: { industry: 'gastronomy' } },
        textKey: 'menu.solutionsGastronomy',
      },
      {
        route: { name: 'solutions', params: { industry: 'services' } },
        textKey: 'menu.solutionsServices',
      },
    ],
  },
  {
    route: { name: 'pricing' },
    textKey: 'menu.pricing',
  },
  {
    route: { name: 'resources' },
    textKey: 'menu.resources',
  },
]
</script>